import { useEffect, useRef, useCallback } from 'react';
import { useAnalytics } from './useAnalytics';

interface Props {
  pageEventName: string;
  eventParams?: any;
  props?: any;
}

const useTrackPage = ({ pageEventName, eventParams = {}, props = {} }: Props) => {
  const { page } = useAnalytics();
  const lastCallRef = useRef<string>();

  const trackPageEvent = useCallback(() => {
    if (!pageEventName) {
      return;
    }

    const callKey = JSON.stringify({ pageEventName, eventParams, props });

    if (callKey !== lastCallRef.current) {
      page(pageEventName, {
        ...eventParams,
        ...props,
      });
      lastCallRef.current = callKey;
    }
  }, [pageEventName, eventParams, props, page]);

  useEffect(() => {
    trackPageEvent();
  }, [trackPageEvent]);
};

export default useTrackPage;
